/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsCountryMessageViewProps } from './lds-country-message';
// @ts-ignore
// import Modal from '../../../eden/eden-content-modal';
import { Info, Modal } from '@churchofjesuschrist/eden-alert';
//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';
import CountryNotice from '../../helpers/utilities/country-notice';
import { format } from '@msdyn365-commerce-modules/utilities';

// Simple country data storage with sessionStorage
const COUNTRY_DATA_KEY = 'country_data';

// Storage utility functions
const getStoredCountryData = () => {
    try {
        const stored = sessionStorage.getItem(COUNTRY_DATA_KEY);
        return stored ? JSON.parse(stored) : null;
    } catch (error) {
        console.log('Error reading stored country data:', error);
        return null;
    }
};

const setStoredCountryData = (countryData: any) => {
    try {
        sessionStorage.setItem(COUNTRY_DATA_KEY, JSON.stringify(countryData));
    } catch (error) {
        console.log('Error storing country data:', error);
    }
};

const CountryMessage: React.FC<ILdsCountryMessageViewProps> = props => {
    const [visible, setVisible] = React.useState(false);
    const [countries, setCountries] = React.useState<any>();
    const [shouldShowLocalCurrency, setShouldShowLocalCurrency] = React.useState<any>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const messageLanguage = props.context.request.locale === 'es' ? 'es' : 'en-us';

    let popUpMessage: any = [];
    //@ts-ignore
    if (props.data.cart && props.data.cart.result && props.data.cart.result.cart) {
        //@ts-ignore
        const userCountry = props.data.cart.result.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country')?.Value.StringValue;
        popUpMessage = CountryNotice.filter(notice => {
            return (
                //@ts-ignore
                notice.countryRegionId === userCountry && notice.lang === messageLanguage
            );
        });
    }

    // Extract current country from cart
    const extractCurrentCountry = (cartData: any): string => {
        if (
            cartData &&
            cartData.cart &&
            cartData.cart.result &&
            cartData.cart.result.cart &&
            cartData.cart.result.cart.ExtensionProperties
        ) {
            const countryProperty = cartData.cart.result.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country');
            return countryProperty?.Value?.StringValue || '';
        }
        return '';
    };

    const getCountry = async () => {
        // Get current country from cart
        const currentCountry = extractCurrentCountry(props.data);
        if (!currentCountry) {
            return null;
        }

        // Check if we have stored country data for this country
        const storedCountryData = getStoredCountryData();

        if (storedCountryData && storedCountryData.countryRegionId === currentCountry) {
            setCountries([storedCountryData]); // Wrap in array to match expected format
            return [storedCountryData];
        }

        // Only call API if we don't have data for this country or not already loading
        if (!isLoading) {
            setIsLoading(true);
            try {
                const result = props.data.countries.result;

                if (result && result.length > 0) {
                    // Find the specific country data
                    const countryData = result.find((item: any) => item.countryRegionId === currentCountry);

                    if (countryData) {
                        // Store only the specific country data
                        setStoredCountryData(countryData);
                        setCountries([countryData]);
                    } else {
                        setCountries(result);
                    }
                }

                setIsLoading(false);
                return result;
            } catch (error) {
                setIsLoading(false);
                return null;
            }
        }

        return countries; // Return existing data if already loading
    };

    React.useEffect(() => {
        setVisible(true);

        // Only call getCountry if we have cart data
        if (props.data && (props.data as any).cart) {
            void getCountry();
        } else {
            console.log('No cart data yet, skipping getCountry');
        }
    }, [props.data]);

    let currentCountry: any;
    if (
        props &&
        props.data &&
        //@ts-ignore
        props.data.cart &&
        //@ts-ignore
        props.data.cart.result &&
        //@ts-ignore
        props.data.cart.result.cart &&
        //@ts-ignore
        props.data.cart.result.cart.ExtensionProperties
    ) {
        //@ts-ignore
        currentCountry = props.data.cart.result.cart
            ? //@ts-ignore
              props.data.cart.result.cart.ExtensionProperties?.find((x: any) => x.Key === 'Country')?.Value.StringValue
            : '';
    }

    let countryData: any;
    if (countries && countries[0]) {
        countryData = countries.filter((country: any) => {
            return country.countryRegionId === currentCountry;
        });
    }

    // let shouldShowLocalCurrency;
    React.useEffect(() => {
        if (countryData && countryData[0] && shouldShowLocalCurrency !== true) {
            // shouldShowLocalCurrency =
            //@ts-ignore
            countryData[0].ExtensionProperties[7].Value?.StringValue === countryData[0].ExtensionProperties[8].Value?.StringValue
                ? null
                : setShouldShowLocalCurrency(true);
        }
    }, [countries]);

    return (
        <div className='row'>
            {/* {visible && popUpMessage.length > 0 ? (
                //@ts-ignore
                <PopUp
                    message={popUpMessage}
                    resources={props.resources}
                    shouldShowLocalCurrency={shouldShowLocalCurrency}
                    config={props.config}
                />
            ) : null} */}
            {visible && props.config.popUpMessage ? (
                //@ts-ignore
                <PopUp message={props.config.popUpMessage} resources={props.resources} shouldShowLocalCurrency={shouldShowLocalCurrency} />
            ) : null}
            {visible && shouldShowLocalCurrency && popUpMessage.length === 0 && (
                // @ts-ignore
                <CurrencyPopUp resources={props.resources} context={props.context} />
            )}
        </div>
    );
};

export default CountryMessage;

export const PopUp: React.FC<any> = ({ message, resources, shouldShowLocalCurrency }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const countryMessage = sessionStorage.getItem('isCountryMessageOpen');
    const closePopUp = () => {
        if (!countryMessage) {
            sessionStorage.setItem('isCountryMessageOpen', 'false');
        }

        setIsOpen(false);
    };
    return (
        <Modal open={countryMessage === 'false' ? false : isOpen}>
            <Info>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ paddingTop: '3px' }}>{resources.currencyHeader}</h3>
                    <div
                        style={{ marginTop: '-8px', fontSize: '16px' }}
                        dangerouslySetInnerHTML={{ __html: message[0].value ? message[0].value : message }}
                    />
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '40px' }}>
                            <Primary onClick={() => closePopUp()} style={{ width: '100%' }}>
                                {resources.closeNotificationLabel}
                            </Primary>
                        </div>
                    </div>
                </div>
            </Info>
        </Modal>
    );
};

export const CurrencyPopUp: React.FC<any> = ({ resources, context }) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const currencyMessage = sessionStorage.getItem('isCurrencyOpen');
    const closePopUp = () => {
        if (!currencyMessage) {
            sessionStorage.setItem('isCurrencyOpen', 'false');
        }
        setIsOpen(false);
    };

    return (
        <Modal open={currencyMessage === 'false' ? false : isOpen}>
            <Info>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ paddingTop: '3px' }}>{resources.currencyHeader}</h3>
                    <span style={{ marginTop: '10px', fontSize: '16px' }}>
                        {format(resources.currencyFeeMessage, context.cultureFormatter.currencyCode)}
                    </span>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '40px' }}>
                            <Primary onClick={() => closePopUp()} style={{ width: '100%' }}>
                                {resources.closeNotificationLabel}
                            </Primary>
                        </div>
                    </div>
                </div>
            </Info>
        </Modal>
    );
};
